import { createSelector } from '@reduxjs/toolkit'

export const isBusinessMerchantFeeEnabled = createSelector(
  (state: App.State) => state.businessTraveller.currentBusinessAccount,
  (currentBusinessAccount): boolean => !!currentBusinessAccount?.business?.enableMerchantFees,
)
